import { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

const initialState = {
  filters: {
    patientFirstName: "",
    patientLastName: "",
    patientDob: "",
    providerFirstName: "",
    providerLastName: "",
    messageType: [],
    dateRange: [],
    provider: [],
    showHiddenMessages: false,
    hideCareTeam: false,
    hideNonCareTeam: false,
    limit: 10,
    page: 1
  }
};


function reducer(state, action) {
  switch (action.type) {
    case 'set':
      return { filters: action.payload };
    case 'save':
      return { filters: action.payload };
    case 'clear':
      return { filters: {
        patientFirstName: "",
        patientLastName: "",
        patientDob: "",
        providerFirstName: "",
        providerLastName: "",
        messageType: [],
        dateRange: [],
        provider: [],
        showHiddenMessages: false,
        hideCareTeam: false,
        hideNonCareTeam: false,
        limit: 10,
        page: 1
      } };
    default:
      throw new Error('Action not found');
  }
}

function useFilters() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const idToken = useSelector((state) => state.tokens.idToken);

  const clearFilters = () => {
    console.log("clearFilters()");
    dispatch({ type: 'clear' });
  };

  const setFilters = (payload) => {
    console.log("setFilters()");
    dispatch({ type: 'set', payload: payload});
  };

  const saveFilters = async (payload) => {
    console.log("saveFilters()");

    try {
      let allItems = [];
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        allItems = []
      } else {
        const filters_url = 'https://' + process.env.REACT_APP_API_DOMAIN + '/user/preferences';
        const headers = {headers: { 'Authorization': 'Bearer ' + idToken }};
        await axios.put(filters_url, payload, headers)
        .then((res) => {
          allItems = res.data.data
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            window.alert("Token invalid - please refresh or log in");
          }
          console.error(err);
        });
      }

      dispatch({ type: 'save', payload: payload });
    } catch (e) {
      console.error(e);
    }

  };
  
  const getFilters = async () => {
    try {
      let allItems = {};
      if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
        allItems = {
          patientFirstName: "JELENE",
          patientLastName: "TEST",
          patientDob: "1975-10-23",
          providerFirstName: "",
          providerLastName: "",
          messageType: ["rad","lab","trans"],
          dateRange: ["30"],
          provider: []
        };
      } else {
        const filters_url = 'https://' + process.env.REACT_APP_API_DOMAIN + '/user/preferences';
        const headers = {headers: { 'Authorization': 'Bearer ' + idToken }};
        await axios.get(filters_url, headers)
        .then((res) => {
          allItems = res.data
          if (Number.isInteger(allItems.dateRange)) {
            let dateList = [allItems.dateRange];
            allItems.dateRange = dateList;
          }
          delete allItems.facility;
          dispatch({ type: 'set', payload: allItems });
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            window.alert("Token invalid - please refresh or log in");
          }
          console.error(err);
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getFilters();
  }, []);

  return [state.filters, getFilters, setFilters, saveFilters, clearFilters];
}

export default useFilters;
